import _ from 'lodash'
import p from 'x/config/platform-specific'

export function getErrorWarningText(error: any): string {
  // console.log('getErrorWarningText => ', error)
  const { error_code, cell_positions } = error
  const errMs = p.op.t(`e_msg_by_error_code.${error_code}.m`)
  // console.log(`errMs => `, errMs)
  let errMessage = `การอัพโหลดไม่สำเร็จ!\nยังไม่มีการอัพเดทข้อมูลใดๆ\nกรุณาแก้ไขให้เรียบร้อยแล้วลองใหม่อีกครั้ง`
  if (!_.isNil(errMs)) {
    errMessage += `\nสาเหตุ: ${errMs}`
  }
  if (!_.isNil(cell_positions)) {
    errMessage += `\nCell ที่ข้อมูลผิดพลาด: `
    errMessage += `${cell_positions.join(', ')}`
  }
  return errMessage
}

export function checkCompleteResponse(response: any): boolean {
  // console.log('checkCompleteResponse => ', response)
  // if (response.statusText === 'OK' && response.status === 200) {
  const { data } = response
  const { status } = data
  if (!_.isNil(status) && status === 'ok') {
    return true
  }
  return false
  // }
  // return false
}

export function showToastUploadFeil() {
  p.op.showToast('การอัพโหลดไม่สำเร็จ', 'danger')
}
